import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({ standalone:false,
  selector: 'app-xero-disconnect-dialog',
  templateUrl: './xero-disconnect-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./xero-disconnect-dialog.component.scss']
})
export class XeroDisconnectDialogComponent {
  title: string= "Title";
  message: string = "Are you sure?";
  confirmButtonText = "Yes";
  constructor(@Inject(MAT_DIALOG_DATA) private data: any, private dialogRef: MatDialogRef<XeroDisconnectDialogComponent>) {
    if(data){
      this.title=data.title;
      this.message=data.message || this.message;
      if(data.buttonText){
        this.confirmButtonText = data.buttonText.ok || this.confirmButtonText;
      }
    }
   }

   onConfirmClick(): void {
    this.dialogRef.close(true);
  }
}
